module.exports = __webpack_public_path__ + "img/karakalpak.c5ed13af.png";